import axios from 'axios';
import { IOrder } from "../components/PendingOrdersPage/pendingOrdersInterfaces"

const generateDocTypeMap = async (orders: Array<IOrder>) => {

    let tempDocTypeArray: Array<number> = [];

    orders.forEach(order => {
        tempDocTypeArray.push(order.docTypeId);
    })

    //only include unique numbers
    const onlyUnique = (value: number, index: any, self: any) => {
        return self.indexOf(value) === index;
    }

    let uniqueDocTypeArray: Array<number> = tempDocTypeArray.filter(onlyUnique);

    //create the Map
    let docTypeMap = new Map();


    let descriptionList = await Promise.all(uniqueDocTypeArray.map((docNum: number) => axios.get(`https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/documenttype?DocumentTypeId=${docNum}`)
        .then(r => r.data.result[0].Description)))

    //fill map with key-pair values
    uniqueDocTypeArray.forEach((docNum: number) => {
        docTypeMap.set(docNum, descriptionList[uniqueDocTypeArray.indexOf(docNum)]);
    })

    //the map is ready
    return docTypeMap;

}

export default generateDocTypeMap;